module.exports = __webpack_public_path__ + "static/Cases2-abc01492e035746b6233c11bf0ea6336.svg";